/* Breadcrumbs.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["textColor"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import BreadcrumbsOriginal, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _7 = "._13t31tcg span{line-height:24px}";
const _6 = "._nzz5oxwj span{font-size:.875rem}";
const _5 = "._1kd31nn1 span{font-weight:400}";
const _4 = "._1uq94jg8 span{font-style:normal}";
const _3 = "._1tjq1nt6 span{color:var(--_v85tu7)}";
const _2 = "._ij3o18aq span{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _ = "._1dzo18uv :after, ._gxv518uv :before{box-sizing:initial}";
const BreadcrumbsWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      textColor
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_v85tu7": ix(__cmplp.textColor || "var(--ds-text-subtle, #44546F)")
      }),
      ref: __cmplr,
      className: ax(["_1dzo18uv _gxv518uv _ij3o18aq _1tjq1nt6 _1uq94jg8 _1kd31nn1 _nzz5oxwj _13t31tcg", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BreadcrumbsWrapper.displayName = 'BreadcrumbsWrapper';
}
export const Breadcrumbs = props => {
  return /*#__PURE__*/_jsx(BreadcrumbsWrapper, {
    textColor: props.textColor,
    className: props.className,
    children: /*#__PURE__*/_jsx(BreadcrumbsOriginal, _objectSpread({}, props))
  });
};
export { BreadcrumbsItem };